import styled from 'styled-components'

export const WorkSpaceContainer = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
`
